import { qdfoodApi } from './constant';
import { IUser } from '@type/user';

export const AUTH_API = {
  urlLogin: `/auth/login/client`,
  urlRegister: `/auth/register`,
  urlVerifyOtp: `/auth/verify-otp`,
  urlResendOtp: `/auth/resend-otp`,
};

export default class authApi {
  static login(data: { email: string; password: string }) {
    return qdfoodApi().post<{
      accessToken: string;
      refreshToken: string;
      user: IUser;
    }>(AUTH_API.urlLogin, data);
  }
  static register(data: { email: string; password: string }) {
    return qdfoodApi().post<IUser>(AUTH_API.urlRegister, data);
  }
  static verifyOtp(data: { email: string; otp: string }) {
    return qdfoodApi().post<IUser>(AUTH_API.urlVerifyOtp, data);
  }
  static resendOtp(data: { email: string }) {
    return qdfoodApi().post<IUser>(AUTH_API.urlResendOtp, data);
  }
}
